export default __webpack_public_path__ + "static/media/fiat.bc2bdbe8.svg";